import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import {Zoom} from 'react-awesome-reveal';
import './MarketMenu.css';
import ClipLoader from "react-spinners/ClipLoader";
import ServingsDropdown from "./ServingsDropdown";
import StockLimitModal from '../StockLimitModal';
// Show "X available" when stock <= this (default 10). Set REACT_APP_STOCK_LOW_THRESHOLD to override.
const STOCK_LOW_THRESHOLD = parseInt(process.env.REACT_APP_STOCK_LOW_THRESHOLD, 10) || 10;

const MarketMenuItem = ({item, onAddToBasket, catHandle, basket, getCartQuantityForVariant, inCarousel}) => {

  const [fillAddBsk, setFillAddBsk] = useState(false)
  const [fillAddBskSml, setFillAddBskSml] = useState(false);
  const [stockLimitModalOpen, setStockLimitModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!item) return;
    setImageLoaded(false);
    const imgUrl = getImageUrl(item);
    if (!imgUrl) {
      setImageLoaded(true);
      return;
    }
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.onerror = () => setImageLoaded(true);
    img.src = imgUrl;
    return () => { img.src = ''; };
  }, [item]);

  useEffect(() => {
    if (item) {
      if (item.variants && item.variants.edges.length > 0) {
        // Capture all variants in a simplified format (include availableForSale for stock mode)
        const allVariants = item.variants.edges.map(edge => ({
          price: parseFloat(edge.node.price.amount),
          servings: edge.node.selectedOptions[0].value, // Assuming "Servings" is always the first option
          id: edge.node.id,
          availableForSale: edge.node.availableForSale ?? true,
          quantityAvailable: edge.node.quantityAvailable != null ? edge.node.quantityAvailable : null
        }));
        setVariants(allVariants);
        setSelectedVariant(allVariants[0]); // Set the first variant as selected initially
      }
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [item]);

  // Function to handle variant selection from dropdown
  const handleVariantChange = (selectedVariantId) => {
    const selected = variants.find(variant => variant.id === selectedVariantId); // Find selected variant using the id
    console.log(selected); // Log the selected variant
    setSelectedVariant(selected); // Update selected variant
  };



const override = {
    display: "flex",
    borderWidth: '5px',
    height: '50px',
    width: '50px',
    position:'absolute',
    left:'calc(50% - 25px)',
    top: 'calc(40%)',
    bottom:'45px',
    zIndex:'0'
};

const overrideSmall = {
    display: "flex",
    borderWidth: '3.5px',
    height: '30px',
    width: '30px',
    position:'absolute',
    left:'calc(50% - 15px)',
    top: 'calc(50% - 15px)',
    bottom:'45px',
    zIndex:'2'
};

const overrideSmaller = {
    display: "flex",
    borderWidth: '3px',
    height: '22px',
    width: '22px',
    position:'absolute',
    left:'calc(50% - 11px)',
    top: 'calc(50% - 11px)',
    bottom:'45px',
    zIndex:'2'
};

const overrideSmallest = {
    display: "flex",
    borderWidth: '2.5px',
    height: '18px',
    width: '18px',
    left:'calc(50% - 9px)',
    top: 'calc(50% - 9px)',
    bottom:'45px',
    zIndex:'2'
};

const getImageUrl = (item) => {
    if (!item) return null;
    return item.images?.edges?.[0]?.node?.src || require('../../images/category_default.png');
};

const getStockQuantity = (variant) => {
  return variant?.quantityAvailable != null ? variant.quantityAvailable : null;
};

const getStockLabel = (variant) => {
  const qty = getStockQuantity(variant);
  if (qty !== null && qty <= 0) return 'Out of stock';
  if (variant?.availableForSale === false) return 'Out of stock';
  if (qty !== null && qty <= STOCK_LOW_THRESHOLD) return `${qty} available`;
  return null; // don't show "X left" when plenty
};

let navigate = useNavigate();
const stockQty = getStockQuantity(selectedVariant);
const stockLabel = getStockLabel(selectedVariant);
const isOutOfStock = selectedVariant?.availableForSale === false || (stockQty !== null && stockQty <= 0);

  const listItem = (
        <li className={`menu_item_container${isOutOfStock ? ' menu_item_container_out_of_stock' : ''}`}>
              <button className='open_modal_sml' onClick={() => {
                  window.scroll(0, 0);
                  navigate('/chatterbox/' + catHandle + '/' + item.handle)
              }}></button>
              <div className='img_option_container'>
                  <div
                      className={fillAddBsk ? 'menu_item_img active' : 'menu_item_img'}
                      alt='Item Image'
                      style={{
                          backgroundImage: `url(${getImageUrl(item)})`,
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                      }}>
                  </div>
                  {!imageLoaded && (
                    <ClipLoader
                        color={'#001e00'}
                        loading={true}
                        cssOverride={override}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                  )}
                  <button className={`item_option_btn${isOutOfStock ? ' item_option_btn_center' : ''}`} onClick={() => {
                      window.scroll(0, 0);
                      navigate('/chatterbox/' + catHandle + '/' + item.handle)
                  }}>ITEM DETAILS
                  </button>
                  {!isOutOfStock && (
                  <button className={fillAddBsk ? 'item_option_btn inactive_2 active ' : 'item_option_btn'}
                          onClick={async () => {
                            if (!selectedVariant) return;
                            setFillAddBsk(true);
                            try {
                              const result = await onAddToBasket(1, selectedVariant.id, { quantityAvailable: stockQty });
                              if (!result?.success || result?.showStockLimitModal) setStockLimitModalOpen(true);
                            } catch {
                              setStockLimitModalOpen(true);
                            } finally {
                              setFillAddBsk(false);
                            }
                          }}
                  ><ClipLoader
                      color={'#fff'}
                      loading={fillAddBsk}
                      cssOverride={overrideSmall}
                      size={'50px'}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                  />ADD TO BASKET
                  </button>
                  )}

              </div>
              <div className='menu_item_info'>
                  <h3 className='menu_item_name'>{item.title.toUpperCase()}</h3>
                  <div className='menu_item_details_container'>

                      <div className='icon_txt_container' style={{margin: "3px 0 5px 0"}}>
                          {isLoading ? (
                              <ClipLoader
                                  color={'#001e00'}
                                  loading={true}
                                  cssOverride={overrideSmallest}
                                  size={'50px'}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                              />
                          ) : (
                              variants.length !== 0 && (
                                  <>
                                      <i className='fas fa-users menu_item_icon_fa menu_item_icon_fa_outline' style={{margin: "2px 0 0 0"}} aria-hidden='true' />
                                      {variants.length === 1 ?
                                          <span className='menu_item_notice'>{selectedVariant.servings} servings</span>
                                          :
                                          <ServingsDropdown variants={variants} selectedVariant={selectedVariant} handleVariantChange={handleVariantChange}/>
                                      }
                                  </>
                              )
                          )}
                      </div>

                      <div className="break"></div>
                      <div className='icon_txt_container' style={{margin: "5px 0 10px 0"}}>
                          <i className={`fas fa-box menu_item_icon_fa menu_item_icon_fa_outline${isOutOfStock ? ' menu_item_icon_fa_out_of_stock' : ''}`} aria-hidden='true' />
                          <span className={`menu_item_notice${isOutOfStock ? ' menu_item_notice_out_of_stock' : ''}`}>
                            {stockLabel || 'In stock'}
                          </span>
                      </div>
                  </div>
                  <div className='price_add_bsk_container'>
                      <h2 className='menu_item_price'>£{selectedVariant?.price?.toFixed(2) || "-"}</h2>
                      {!isOutOfStock && (
                      <button className={fillAddBskSml ? 'item_option_btn_small vanish' : 'item_option_btn_small'}
                              onClick={async () => {
                                if (!selectedVariant) return;
                                setFillAddBskSml(true);
                                try {
                                  const result = await onAddToBasket(1, selectedVariant.id, { quantityAvailable: stockQty });
                                  if (!result?.success || result?.showStockLimitModal) setStockLimitModalOpen(true);
                                } catch {
                                  setStockLimitModalOpen(true);
                                } finally {
                                  setFillAddBskSml(false);
                                }
                              }}>
                          <img
                              className={fillAddBskSml ? 'basket_icon_add vanish' : 'basket_icon_add'}
                              alt='Basket Icon'
                              src={require('./../../images/basket_icon_green.png')}
                              loading="eager"
                          />
                          <span className={fillAddBskSml ? 'basket_plus vanish' : 'basket_plus'}>+</span>
                          <ClipLoader
                              color={'#001e00'}
                              loading={fillAddBskSml}
                              cssOverride={overrideSmaller}
                              size={'50px'}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                          />
                      </button>
                      )}
                  </div>
              </div>
          </li>
  );

  return (
    <>
      {inCarousel ? listItem : (
        <Zoom triggerOnce={true} className='zoom-container'>
          {listItem}
        </Zoom>
      )}
      <StockLimitModal
        isOpen={stockLimitModalOpen}
        onClose={() => setStockLimitModalOpen(false)}
      />
    </>
  )
}

export default MarketMenuItem
